<template>
  <div id="decor_detail" class="h-full pb-10 overflow-y-auto" v-if="isLoaded">
    <div class="mb-3 h-1/2">
      <img v-if="decor.thumbnail" class="classen__rounded" :src="decor.thumbnail"/>
      <img v-else src="../../../assets/media/NoImage.png" alt="no image"/>
    </div>
    <div class="grid grid-cols-1 gap-5 xl:grid-cols-2">
      <div class="properties">
        <c-list-item :data="decorData.name" :translation-key="'decorName'"/>
        <c-list-item :data="decorData.number" :translation-key="'decorNumber'"/>
        <c-list-item :data="decorData.plankType" :translation-key="'plankType'"/>
        <c-list-item :data="decorData.plankColor" :translation-key="'plankColor'"/>
        <c-list-item :data="decorData.material" :translation-key="'material'"/>
        <c-list-item :data="decorData.width" :translation-key="'plankWidth'"/>
      </div>

      <div id="products" class="properties">
        <div id="itemListElement" class="text-left border-b-2 border-classen__secondary h-auto">
          <div>
            <label>{{ getTranslation('linkedProducts') }}</label>
          </div>
          <div class="overflow-y-auto">
            <template v-for="product in decorData.products.data">
              <label class="block font-bold"
                     :class="{'underline cursor-pointer': showLinks}"
                     @click="redirectToProduct(product)">{{ product.externalId }} {{ product.name }}</label>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import ListItem from "../ListItem";
import getTranslation from "../../../mixins/getTranslation";
import EventBus from "../../../services/EventBus";

export default {
  name: 'DecorDetailForm',

  mixins: [getTranslation],

  props: {
    decor: {required: true},
    showLinks: {required: true, type: Boolean, default: true}
  },

  components: {
    'c-list-item': ListItem
  },

  data() {
    return {
      decorData: null,
      isLoaded: false,
    }
  },

  async created() {
    this.decorData = this.decor;
    this.isLoaded = true
  },

  methods: {
    redirectToProduct(product) {
      if (!this.showLinks) {
        return
      }

      EventBus.fire('set-active_product', product)
    }
  }
}
</script>
<style scoped>

img {
  width: 65%;
  max-height: 100%;
  object-fit: cover;
}

#products {
  height: fit-content;
}

#itemListElement {
  display: grid;
  min-height: 35px;
  grid-template-columns: 40% 60%
}
</style>
